import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { passengerCMSApi, post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../../constants";
import { useTravellerEssentialsListDocumentDetails } from "../travller.hooks";

export const AddEditTravllerEssentialsList = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [parentId, setParentId] = useState<any>();
  const [currentAirport] = useLocalStorage("currentAirport", null);

  const {
    data: editSubCategories,
    isLoading: drilldownLoading,
    refetch: refetchSubCategories,
  } = useTravellerEssentialsListDocumentDetails(query.get("editId") || "");

  const {
    data: editSubCategoriesById,
    isLoading: isLoadingSubCategories,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) refetchDocument();
    if (query.get("editId")) refetchSubCategories();
  }, [query.get("id"), query.get("editId")]);
  useEffect(() => {
    refetchSubCategories();
  }, []);
  const getRecords = () => {
    let url = `/api/traveller-essentials-all-fields?airport=${currentAirport}`;
    passengerCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setParentId(envelopes?.[0]?.id);
        }
      })
      .catch((err) => {
        setParentId("");
      });
  };
  useEffect(() => {
    getRecords();
  }, []);
  const epcApplicationsFormConfig: FormConfig = {
    initialValues: {
      link: decodeHTML(editSubCategoriesById?.payload?.link) || decodeHTML(editSubCategories?.link) || "",

      published: editSubCategoriesById
        ? editSubCategoriesById.payload.published === "True" || editSubCategoriesById.payload.published === true
        : editSubCategories
          ? editSubCategories.published === "True" || editSubCategories?.published === true
          : false,

      image: editSubCategoriesById?.payload
        ? [
            {
              uid: "-1",
              name: "image.jpg",
              status: "done",
              url: decodeHTML(editSubCategoriesById?.payload?.image),
            },
          ]
        : editSubCategories
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: decodeHTML(editSubCategories?.image),
              },
            ]
          : "",

      document: editSubCategoriesById?.payload
        ? [
            {
              uid: "-1",
              name: "document.pdf",
              status: "done",
              url: decodeHTML(editSubCategoriesById?.payload?.document),
            },
          ]
        : editSubCategories
          ? [
              {
                uid: "-1",
                name: "document.pdf",
                status: "done",
                url: decodeHTML(editSubCategories?.document),
              },
            ]
          : "",
    },
    fields: fields.travellerEssentialsList,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    try {
      let imageKeys: any = ["image", "document"];
      for (const key of imageKeys) {
        try {
          let field = data[key];
          if (field[0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "PASSENGER");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              data[key] = res.response.data;
            }
          } else {
            data[key] = data[key][0].url;
          }
        } catch (error) {}
      }

      const payload = {
        action,
        method,
        airportName: currentAirport,
        module: "Home Page",
        subModule: "travellerEssentials_travellerEssentialsList",
        type: "DEDICATED",
        application: "PASSENGER_ECMS",
        reviewNotes,
        appList: [
          {
            appName: "PASSENGER_ECMS",
            apiUrl,
          },
        ],
        payload: {
          ...(action === "UPDATE" && {
            id: editSubCategories?.id || editSubCategoriesById?.payload?.id,
          }),
          ...data,
          airport: currentAirport,
          parent_id: editSubCategories?.parent_id || editSubCategoriesById?.payload?.parent_id || parentId,
        },
        status,
      };

      // Submit to API
      if (query.get("id")) {
        await put(`/management/update-document?approvalId=${query.get("id")}`, payload);
        openToast({
          content: status === "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
          type: "success",
        });
        navigate(
          status === "PENDING"
            ? "/dedicated/status-information?activeTab=pending"
            : "/dedicated/status-information?activeTab=draft"
        );
      } else {
        await post("/management/publish", payload);
        openToast({
          content: status === "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
          type: "success",
        });
        navigate(
          status === "PENDING"
            ? "/dedicated/status-information?activeTab=pending"
            : "/dedicated/status-information?activeTab=draft"
        );
      }
    } catch (error) {
      openToast({
        content: "Failed to save data",
        type: "error",
      });
      console.error("Error submitting Traveller Essential:", error);
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingSubCategories}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Traveller Essential`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingSubCategories || drilldownLoading}
        config={epcApplicationsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${passengerHost}/api/traveller-essential-paragraph/${editSubCategories?.id || editSubCategoriesById?.payload?.id}` : `${passengerHost}/api/traveller-essential-paragraph`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Homepage"
      />
    </ContentWrapper>
  );
};
